export default "<app-header></app-header>\n<main>\n    <router-outlet></router-outlet>\n</main>"